module.exports = __webpack_public_path__ + "img/no_list.6f3a9b78.png";